import React, { useContext, useState } from "react";
import styles from "./NextVisit.module.scss";
import { Context } from "../Store";

const NextVisit = () => {
  const state = React.useContext(Context); 
  let country = state.country;

  const usLink = "https://electricshuffle.com/us?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit";
  const ukLink = "https://electricshuffle.com/uk/book?utm_source=Stories&utm_medium=cta&utm_campaign=plan_next_visit";

  const countryLink = country === "us" ? usLink : ukLink;

  return (
    <div className={`${styles.nextVisit} section section--padded`}>
      <h2>
        Ready for <br /> another round?
      </h2>
      <p>Keep the good times rolling! Book now and let’s create your next great Story.</p>
      <a href={countryLink} className={styles.ctaButton} target="_blank" rel="noopener noreferrer">
        PLAN YOUR NEXT VISIT
      </a>
    </div>
  );
};

export default NextVisit;
